import {doc} from './docs.js';
import {START} from 'messaging/message-types.js';

doc(
    "counter", {
        min: "",
        max: "",
    }, "counts number of input messages received",
    () => 2,
    {
        tags: "Ticker",
        isHot: true,
        inlets: ["Input", "Direction", "Reset"]
    }
);
    
export const counter = (object, min, max) => {
    let count = 0;
    let direction = 1;
    object.needsStart = true;
    // object.needsLoad = true;

    object.setAttribute("Send min on load", true, (x) => {
        // object.needsLoad = x;
    });

    return (msg) => {
        let [type, value] = msg;
        switch (type) {
        case START:
            count = min();
            return ;//[count];
        case "Direction":
            direction= value;
            return;
        case "Reset":
            count = min();
            return [count];
        }
        count+=direction;
        if (count >= max()) {
            count = min() + count - max();
            return [count, "bang"];
        }
        return count;
    };
};


doc(
    "simpleCounter", {
        value: "",
        min: "",
        max: "",
    }, "counts number of input messages received",
    undefined,
    {
        tags: "Ticker",
        isHot: true,
        inlets: ["decrement", "increment", "value"]
    }
);
    
export const simpleCounter = (object, value, min, max) => {
    let count = undefined;
    let direction = 1;
    // object.needsStart = true;

    return (msg) => {
        if (count === undefined) {
            count = value() || 0;
        }
        let [type, val] = msg;
        switch (type) {
        case "decrement":
            count--;
            if (count < min()) {
                count = min();
            }
            return [count];
        case "increment":
            count++;
            if (count > max()) {
                count = max();
            }
            return [count];
        case "value":
            count = val;
            return [count];
        }
        return count;
    };
};

